import { validationType } from './validationConstants';

export const isFormValid = (globalFormState) => {
  const invalidValueFound = Object.values(globalFormState.validation).find(v => !v.valid)
  return !invalidValueFound
}

export const getMultiFieldErrors = (globalFormState) => {
  const badValidations = Object.values(globalFormState.validation).filter(v => 
    v.validationType === validationType.MULTI_FIELD && !v.valid )
  return badValidations
}